/**
 * Bilingual copy for the ProductBody component.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  howItWorks: 'How it works',
  seeIt: 'See it',
  productVideos: 'Product videos',
  insideTheModule: 'Inside the module',
  keyCapabilities: 'Key capabilities',
  inDetail: 'In detail',
  whatYouCanSetUp: 'What you can set up and run',
  whyTeamsUseIt: 'Why teams use it',
  benefitsTitle: 'Benefits for your business',
  alsoIncluded: 'Also included',
  platformExtras: 'Platform extras',
  connected: 'Connected',
  relatedTitle: 'Related modules and guides',
  ctaTitle: 'See this module in your own process',
  ctaDescription:
    'We will walk through the screens with your team, or you can read the user guide on docs.akas.co.',
  contactUs: 'Contact us',
  openUserGuide: 'Open user guide',
  tryLiveDemo: 'Try a live demo',
  seeLiveDemos: 'See live demos',
};

export type Copy = typeof en;

export const km: Copy = {
  howItWorks: 'របៀបដំណើរការ',
  seeIt: 'មើលវាក្នុងការអនុវត្ត',
  productVideos: 'វីដេអូផលិតផល',
  insideTheModule: 'ក្នុងម៉ូឌុលនេះ',
  keyCapabilities: 'មុខងារសំខាន់ៗ',
  inDetail: 'លម្អិត',
  whatYouCanSetUp: 'អ្វីដែលអ្នកអាចដំណើរការបាន',
  whyTeamsUseIt: 'ហេតុអ្វីក្រុមការងារប្រើវា',
  benefitsTitle: 'អត្ថប្រយោជន៍សម្រាប់អាជីវកម្មរបស់អ្នក',
  alsoIncluded: 'រួមបញ្ចូលផងដែរ',
  platformExtras: 'មុខងារបន្ថែម',
  connected: 'ជាដំណោះស្រាយទាក់ទង',
  relatedTitle: 'ម៉ូឌុល និងមគ្គុទ្ទេសក៍ដែលទាក់ទង',
  ctaTitle: 'មើលម៉ូឌុលនេះក្នុងដំណើរការរបស់អ្នក',
  ctaDescription:
    'យើងនឹងបង្ហាញអេក្រង់ទាំងនោះជាមួយក្រុមរបស់អ្នក ឬអ្នកក៏អាចអានមគ្គុទ្ទេសក៍នៅ docs.akas.co បានដែរ។',
  contactUs: 'ទំនាក់ទំនងយើង',
  openUserGuide: 'បើកមគ្គុទ្ទេសក៍',
  tryLiveDemo: 'សាកល្បងការបង្ហាញផ្ទាល់',
  seeLiveDemos: 'មើលការបង្ហាញផ្ទាល់',
};
